const ProductsBanner = ({product, title, body}) => {
  return (
    <>
      <div className={`banner domains ${product} section `} id="home">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1>{title}</h1>
          <p>
            {body}
          </p>
        </div>
      </div>
    </>
  );
};

export default ProductsBanner;
